var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowCircledBottomRight = function SvgArrowCircledBottomRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5356 9.87866C16.5356 9.32637 16.0879 8.87866 15.5356 8.87866C14.9833 8.87866 14.5356 9.32637 14.5356 9.87866L14.5356 13.1213L9.17165 7.75734C8.78112 7.36681 8.14796 7.36681 7.75743 7.75734C7.36691 8.14786 7.36691 8.78102 7.75743 9.17155L13.1214 14.5355L9.87875 14.5355C9.32647 14.5355 8.87875 14.9832 8.87875 15.5355C8.87875 16.0878 9.32647 16.5355 9.87875 16.5355L15.5356 16.5355C16.0879 16.5355 16.5356 16.0878 16.5356 15.5355L16.5356 9.87866Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6569 6.3431C14.5327 3.21891 9.46734 3.2189 6.34315 6.3431C3.21895 9.46729 3.21895 14.5326 6.34315 17.6568C9.46734 20.781 14.5327 20.781 17.6569 17.6568C20.7811 14.5326 20.7811 9.4673 17.6569 6.3431ZM19.0711 4.92889C15.1658 1.02364 8.83418 1.02364 4.92893 4.92888C1.02369 8.83413 1.02369 15.1658 4.92893 19.071C8.83418 22.9763 15.1658 22.9763 19.0711 19.071C22.9763 15.1658 22.9763 8.83413 19.0711 4.92889Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })))));
};
export { SvgArrowCircledBottomRight as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-circled-bottom-right.6447138e.svg";